import styled from "styled-components";

export const Page = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 100vh;
    padding: 1.5rem;
`;

export const Card = styled.div`
    width: 100%;
    max-width: 24rem;
    background-color: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: 0.75rem;
    padding: 2rem;
`;

export const Brand = styled.div`
    display: flex;
    align-items: center;
    gap: 0.6rem;
    margin-bottom: 1.5rem;

    > img {
        width: 2rem;
        height: 2rem;
        display: block;
    }

    > span {
        color: var(--color-accent);
        font-weight: 800;
        font-size: 1.3rem;
        letter-spacing: -0.02em;
    }
`;

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 0.9rem;

    > h1 {
        margin: 0 0 0.25rem 0;
        padding: 0;
        font-size: 1.3rem;
    }

    > p.subtitle {
        margin: 0 0 0.5rem 0;
        padding: 0;
        color: var(--color-text-muted);
        font-size: 0.9rem;
    }
`;

export const CheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 0.3rem;
`;

export const CheckboxRow = styled.label`
    display: flex;
    align-items: flex-start;
    gap: 0.6rem;
    cursor: pointer;

    input {
        margin-top: 0.2rem;
        accent-color: var(--color-accent);
        width: 1.05rem;
        height: 1.05rem;
        flex-shrink: 0;
    }

    > div {
        display: flex;
        flex-direction: column;
    }

    strong {
        font-size: 0.9rem;
    }

    span {
        font-size: 0.8rem;
        color: var(--color-text-muted);
    }
`;

export const Confirmation = styled.div`
    text-align: center;

    > h1 {
        margin: 0 0 0.5rem 0;
        font-size: 1.3rem;
    }

    > p {
        color: var(--color-text-muted);
        font-size: 0.9rem;
        margin: 0;
    }
`;
